
import type { History } from 'history';
import type { IRouteConfigSettings } from '../../interface/config';
import type { IRouteTour } from './interface';
import type { IQueryURL } from '../../interface/util';
import type { IRouteActionResult, IRouteName } from '../../interface/route';
import type IController from '../../controllers/tour';

const loadController = (): Promise<typeof IController> => {
    return new Promise(function(resolve, reject) {
        import('../../controllers/tour')
            .then(controller => resolve(controller.default))
            .catch(error => reject(error));
    })
}

function push(settings: IRouteConfigSettings, query: IQueryURL, history: History, props: IRouteTour): Promise<IRouteActionResult> {
    return new Promise(async function(resolve, reject) {
        try {
            const controller = await loadController();
            const render = await controller.canRender(props);

            let result: IRouteActionResult = {
                didLaunchAction: false,
            };

            if ( render.hasEnoughDataToRender ) {
                history.push(settings.pathPrefix + query.assemble(props))
                result.didLaunchAction = true;
            } else {
                result.alternativeRoutePayload = {
                    ...props,
                    ...render.additionalRouteDataNeeded,
                };
                result.alternativeRouteRequested = (render.suggestedAlternativeRoute || 'TourSelect') as IRouteName;
            }

            resolve(result);
        } catch(error) {
            reject(error);
        }
    });
} 

function replace(settings: IRouteConfigSettings, query: IQueryURL, history: History, props: IRouteTour): Promise<IRouteActionResult> {
    return new Promise(async function(resolve, reject) {
        try {
            const controller = await loadController();
            const render = await controller.canRender(props);

            let result: IRouteActionResult = {
                didLaunchAction: false,
            };

            if ( render.hasEnoughDataToRender ) {
                history.push(settings.pathPrefix + query.assemble(props))
                result.didLaunchAction = true;
            } else {
                result.alternativeRoutePayload = {
                    ...props,
                    id: render.additionalRouteDataNeeded.tour.id,
                };

                result.alternativeRouteRequested = (render.suggestedAlternativeRoute || 'TourSelect') as IRouteName;
            }

            resolve(result);
        } catch(error) {
            reject(error);
        }
    });
} 

const exports = {
    push,
    replace,
}

export default exports 
